/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-22 14:31:51
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-13 14:59:35
 * @FilePath: /dsicm-admin-web/src/api/permissions.js
 */
//角色表接口  与角色资源表接口 角色组

//引入接口文档
import req from '@/utils/req.js'


//角色组列表查询
export function api_getperuserinfo(params) {
    return req.get("/admin/role-group", params);
}

//添加角色组
export function api_addperuserinfo(params) {
    return req.post("/admin/role-group", params);
}

//角色组更新
export function api_updateperuserinfo(params) {
    return req.put("/admin/role-group", params);
}

//删除角色组
export function api_delperuserinfo(id) {
    return req.delete(`/admin/role-group/${id}`);
}

//添加子角色
export function api_postresources(params) {
    return req.post("/admin/role", params);
}

//子角色修改
export function api_editresources(params) {
    return req.put("/admin/role", params);
}

//子角色删除
export function api_delresources(id) {
    return req.delete(`/admin/role/${id}`);
}

//获取子角色的权限菜单
export function api_get_role_sources(params) {
    return req.get("/admin/role-resource/role-id", params);
}

//获取权限树
export function api_get_admin_resource(params) {
    return req.get("/admin/resource", params);
}


//分配子角色权限菜单
export function api_add_role_sources(params) {
    return req.post("/admin/role-resource/add-list", params);
}


//分配子角色权限菜单
export function api_department(params) {
    return req.get("/admin/department", params);
}



//所属平下拉框接口
export function api_hospital(params={}) {
    return req.post("/admin/hospital/list", params);
}


//角色类型下拉框接口
export function api_get_role(params) {
    return req.get("/admin/role", params);
}


